import React, { useEffect, useState } from "react";
import { Stack } from "@mui/joy";
import {
  loadTossPayments,
  TossPaymentsPayment,
} from "@tosspayments/tosspayments-sdk";
import { useRecoilState, useRecoilValue } from "recoil";
import { userAtom } from "../../recoil/userAtom";
import { paymentOrderAtom } from "../../recoil/paymentOrderAtom";
import { useQuery } from "@tanstack/react-query";
import {
  PAYMENT_DOMAIN,
  PAYMENT_ORDER_DETAIL_ENDPOINT,
  paymentApi,
} from "../../api/paymentApi";
import useGetDeviceInfo from "../../hooks/useGetDeviceInfo";
import ContentTemplateV2 from "../../components/task/content/ContentTemplateV2";
import { useSearchParams } from "react-router-dom";
import {
  PlanKey,
  planKeyToName,
} from "../../components/task/payment/planTypes";

export default function TossPayments() {
  const tossPaymentsClientKey = process.env.REACT_APP_TOSSPAYMENTS_CLIENT_KEY!!;
  const [searchParams] = useSearchParams();
  const planItemKey = (searchParams.get("plan") || "challenger") as PlanKey;

  const [tossPaymentsPayment, setTossPaymentsPayment] =
    useState<TossPaymentsPayment | null>();

  const user = useRecoilValue(userAtom);
  const [paymentOrderState, setPaymentOrderState] =
    useRecoilState(paymentOrderAtom);

  const { refetch: getPaymentOrder } = useQuery(
    [PAYMENT_DOMAIN, PAYMENT_ORDER_DETAIL_ENDPOINT],
    () => paymentApi.getOrderDetail(),
    {
      enabled: false,
      onSuccess: (data) => {
        if (data && data.result) {
          setPaymentOrderState(data.result);
        }
      },
    }
  );

  useEffect(() => {
    if (user?.accessToken) {
      getPaymentOrder();
    } else {
      console.error("유저 정보 없음");
    }
  }, []);

  async function requestTossPayments() {
    if (tossPaymentsPayment) {
      try {
        await tossPaymentsPayment?.requestPayment({
          method: "CARD",
          amount: {
            currency: "KRW",
            value: paymentOrderState.isCarePass
              ? 36500
              : user?.pricingModel === "koreanmania" &&
                  planItemKey === "starter"
                ? 255000
                : user?.pricingModel === "koreanmania" &&
                    planItemKey === "challenger"
                  ? 315000
                  : user?.pricingModel === "koreanmania" &&
                      planItemKey === "master"
                    ? 385000
                    : planItemKey === "starter"
                      ? 295000
                      : planItemKey === "challenger"
                        ? 395000
                        : planItemKey === "master"
                          ? 465000
                          : 395000,
          },
          orderId: paymentOrderState.orderId!!,
          orderName: `디스턴싱 ${planKeyToName[planItemKey]} 플랜 / 100일${paymentOrderState?.isCarePass ? " (CarePass 적용가)" : ""}`,
          successUrl: window.location.origin + "/toss-payments/success",
          failUrl: window.location.origin + "/toss-payments/fail",
          customerEmail: paymentOrderState.customerEmail,
          customerName: paymentOrderState.customerName,
          card: {
            useEscrow: false,
            flowMode: "DEFAULT",
            useCardPoint: false,
            useAppCardOnly: false,
          },
        });
      } catch (error) {
        // 에러 처리하기
        console.error(error);
      }
    }
  }

  useEffect(() => {
    async function fetchTossPaymentsPayment() {
      if (tossPaymentsClientKey && paymentOrderState?.customerKey) {
        const tossPayments = await loadTossPayments(tossPaymentsClientKey);
        const payment = tossPayments.payment({
          customerKey: paymentOrderState.customerKey,
        });

        setTossPaymentsPayment(payment);
      }
    }

    fetchTossPaymentsPayment();
  }, [tossPaymentsClientKey, paymentOrderState]);

  useEffect(() => {
    if (tossPaymentsPayment) {
      requestTossPayments();
    }
  }, [tossPaymentsPayment]);

  const { homeIndicatorHeight } = useGetDeviceInfo();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - homeIndicatorHeight
  );

  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  return (
    <ContentTemplateV2 noPadding isWide setContainerHeight={setContainerHeight}>
      {containerHeight > 0 && (
        <Stack sx={{ pb: "150px", opacity: floatingAreaHeight > 0 ? 1 : 0 }}>
          <Stack
            spacing={"30px"}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
              px: "20px",
              // height: `calc(${containerHeight}px - ${floatingAreaHeight}px)`,
              // pt: "50px",
            }}
          ></Stack>
        </Stack>
      )}
    </ContentTemplateV2>
  );
}
